module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Carrot-1e518954593934582c77dafbe198b429.svg";